/* INAYAH — Upsell interactions v107 (detach non-matching size options on iOS Safari)
 * Renders:
 *   .inayah-upsell                       wrapper
 *   .inayah-upsell__slide.is-active      one product visible at a time
 *   [data-slide-arrow=prev|next]         flip between products
 *   [data-photo-arrow=prev|next]         cycle product photos within active slide image
 *   [data-inayah-sizeselect]             size dropdown -> enables Add to Bag
 *   .inayah-upsell__color                color swatch -> swap image + filter sizes
 *   [data-inayah-drawer-add]             Add to Bag link
 *
 * All listeners are capture-phase to win against Minimog cart scripts.
 */
(function () {
  'use strict';
  if (window.__inayahUpsellV103) return;
  window.__inayahUpsellV103 = true;

  // Update Minimog .sf-cart-count badge from /cart.js item_count
  function refreshCartCountBadge() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var n = cart.item_count;
        document.querySelectorAll('.sf-cart-count').forEach(function (el) { el.textContent = n; });
        // Also toggle header cart-has-items class
        document.querySelectorAll('.sf-header').forEach(function (h) {
          if (n > 0) h.classList.add('cart-has-items'); else h.classList.remove('cart-has-items');
        });
      })
      .catch(function () {});
  }

  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }
  function getWrap(el) { return closest(el, '.inayah-upsell'); }
  function getSlide(el) { return closest(el, '.inayah-upsell__slide'); }

  /* ----------------------------------------------------------------
   * Init: show first slide active in every upsell wrapper
   * -------------------------------------------------------------- */
  function initWrap(wrap) {
    if (!wrap || wrap.__inayahInited) return;
    wrap.__inayahInited = true;
    var slides = wrap.querySelectorAll('.inayah-upsell__slide');
    slides.forEach(function (s, i) {
      if (i === 0) s.classList.add('is-active'); else s.classList.remove('is-active');
    });
    updateNav(wrap);
    // hide options that don't match default color, then sync CTA to any pre-selected size
    slides.forEach(function (s) {
      applyColorFilterToSelect(s);
      syncCtaFromSelect(s);
    });
  }

  // If Liquid pre-selected a size option (cart_size match), reflect that in CTA on load
  function syncCtaFromSelect(slide) {
    var sel = slide.querySelector('[data-inayah-sizeselect]');
    if (!sel) return;
    var cta = slide.querySelector('[data-inayah-drawer-add]');
    if (!cta) return;
    var opt = sel.options[sel.selectedIndex];
    if (!opt || opt.hasAttribute('data-placeholder') || !opt.value || opt.hidden) {
      cta.setAttribute('data-needs-size', '');
      cta.classList.remove('is-ready');
      cta.removeAttribute('data-variant-id');
      cta.textContent = 'Select Size';
      return;
    }
    cta.removeAttribute('data-needs-size');
    cta.removeAttribute('disabled');
    cta.classList.add('is-ready');
    cta.setAttribute('data-variant-id', opt.value);
    cta.textContent = 'Add to Bag';
    var fmt = opt.getAttribute('data-price-formatted');
    var priceEl = slide.querySelector('[data-price]');
    if (priceEl && fmt) priceEl.textContent = fmt;
  }

  function updateNav(wrap) {
    var slides = wrap.querySelectorAll('.inayah-upsell__slide');
    var activeIdx = -1;
    slides.forEach(function (s, i) { if (s.classList.contains('is-active')) activeIdx = i; });
    var prev = wrap.querySelector('[data-slide-arrow="prev"]');
    var next = wrap.querySelector('[data-slide-arrow="next"]');
    if (prev) prev.disabled = activeIdx <= 0;
    if (next) next.disabled = activeIdx >= slides.length - 1;
  }

  function showSlide(wrap, idx) {
    var slides = wrap.querySelectorAll('.inayah-upsell__slide');
    if (idx < 0 || idx >= slides.length) return;
    slides.forEach(function (s) { s.classList.remove('is-active'); });
    slides[idx].classList.add('is-active');
    updateNav(wrap);
  }

  function init() {
    document.querySelectorAll('.inayah-upsell').forEach(initWrap);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init when drawer re-renders
  document.addEventListener('cart:updated', init);
  document.addEventListener('cart:refresh', init);
  // Re-init when Minimog injects/rebuilds the drawer. Minimog lazy-loads the drawer body
  // (which contains the upsell) via AJAX on open, so the fresh .inayah-upsell needs init() to
  // activate its first slide. We must observe document.body to catch that injection no matter
  // where Minimog swaps the DOM (a previous attempt scoping to the drawer's class attribute
  // missed the body injection — the upsell rendered but its slides stayed collapsed). To keep
  // it cheap on this script-heavy page, COALESCE mutation bursts into one init() per ~60ms
  // instead of running on every mutation.
  var reinitTimer = null;
  function scheduleReinit() {
    if (reinitTimer) return;
    reinitTimer = setTimeout(function () { reinitTimer = null; init(); }, 60);
  }
  new MutationObserver(scheduleReinit).observe(document.body, { childList: true, subtree: true });

  /* ----------------------------------------------------------------
   * Slide arrows (top-right): prev / next product
   * -------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var arrow = closest(e.target, '[data-slide-arrow]');
    if (!arrow) return;
    e.preventDefault(); e.stopPropagation();
    var wrap = getWrap(arrow);
    if (!wrap) return;
    var slides = wrap.querySelectorAll('.inayah-upsell__slide');
    var activeIdx = -1;
    slides.forEach(function (s, i) { if (s.classList.contains('is-active')) activeIdx = i; });
    var dir = arrow.getAttribute('data-slide-arrow') === 'next' ? 1 : -1;
    showSlide(wrap, activeIdx + dir);
  }, true);

  /* ----------------------------------------------------------------
   * Photo arrows (on image): cycle photos within active slide
   * -------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var arrow = closest(e.target, '[data-photo-arrow]');
    if (!arrow) return;
    e.preventDefault(); e.stopPropagation();
    var slide = getSlide(arrow);
    if (!slide) return;
    var img = slide.querySelector('[data-img]');
    if (!img) return;
    var photos;
    try { photos = JSON.parse(slide.getAttribute('data-photos') || '[]'); } catch (err) { photos = []; }
    if (!photos.length) return;
    var idx = parseInt(slide.getAttribute('data-photo-idx') || '0', 10);
    var dir = arrow.getAttribute('data-photo-arrow') === 'next' ? 1 : -1;
    idx = (idx + dir + photos.length) % photos.length;
    slide.setAttribute('data-photo-idx', String(idx));
    img.setAttribute('src', photos[idx]);
  }, true);

  /* ----------------------------------------------------------------
   * Color swatch: swap image + filter visible size options
   * -------------------------------------------------------------- */
  // iOS Safari ignores option.hidden — must physically detach unmatched options.
  // Stash all options on first call, then rebuild the select with only matching ones.
  function applyColorFilterToSelect(slide, autoSelectFirstAvailable) {
    var color = slide.getAttribute('data-current-color') || '';
    var select = slide.querySelector('[data-inayah-sizeselect]');
    if (!select) return;

    // Stash all options on first call (preserves the master list)
    if (!select.__inayahAllOptions) {
      var all = [];
      Array.prototype.forEach.call(select.options, function (opt) {
        all.push(opt);
      });
      select.__inayahAllOptions = all;
    }

    var preservedSize = '';
    var prevOpt = select.options[select.selectedIndex];
    if (prevOpt && !prevOpt.hasAttribute('data-placeholder')) {
      preservedSize = prevOpt.getAttribute('data-size') || '';
    }

    // Clear current options
    while (select.firstChild) select.removeChild(select.firstChild);

    // Re-add placeholder + only the options matching active color (or all if no color filter)
    var seenSizes = {};
    var newSelectedIdx = 0;
    select.__inayahAllOptions.forEach(function (opt) {
      var isPh = opt.hasAttribute('data-placeholder');
      var oc = opt.getAttribute('data-color') || '';
      if (isPh) {
        select.appendChild(opt);
        return;
      }
      // skip if doesn't match color filter
      if (color !== '' && oc !== '' && oc !== color) return;
      // skip if we've already added this size for this color (defensive against true variant duplicates)
      var sizeKey = (opt.getAttribute('data-size') || '') + '|' + oc;
      if (seenSizes[sizeKey]) return;
      seenSizes[sizeKey] = true;
      select.appendChild(opt);
    });

    // Restore previously selected size if it's still in the list
    var restored = false;
    if (preservedSize) {
      Array.prototype.forEach.call(select.options, function (opt, i) {
        if (restored) return;
        if (opt.getAttribute('data-size') === preservedSize && !opt.disabled) {
          select.selectedIndex = i;
          restored = true;
        }
      });
    }
    if (!restored) {
      if (autoSelectFirstAvailable) {
        // Color change: the previously-picked size isn't offered in this color. Auto-select
        // the first available size instead of dead-ending on the "Select" placeholder. This
        // only fires on an explicit color switch (never first load), so it can't cause a
        // wrong-size add — the customer chose this color, and one size is always valid.
        var firstReal = -1;
        Array.prototype.forEach.call(select.options, function (opt, i) {
          if (firstReal === -1 && !opt.hasAttribute('data-placeholder') && !opt.disabled && opt.value) {
            firstReal = i;
          }
        });
        select.selectedIndex = firstReal >= 0 ? firstReal : 0;
      } else {
        // Initial load: keep the "Select Size" gate (no auto-add of a guessed size).
        select.selectedIndex = 0;
      }
    }
  }

  document.addEventListener('click', function (e) {
    var btn = closest(e.target, '.inayah-upsell__color');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var slide = getSlide(btn);
    if (!slide) return;
    var color = btn.getAttribute('data-color') || '';
    slide.setAttribute('data-current-color', color);

    // highlight
    slide.querySelectorAll('.inayah-upsell__color').forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');

    // swap image
    var img = slide.querySelector('[data-img]');
    var newSrc = btn.getAttribute('data-color-img');
    if (img && newSrc) {
      img.setAttribute('src', newSrc);
      slide.setAttribute('data-photo-idx', '0');
      // Update photos array to start with new color image
      try {
        var photos = JSON.parse(slide.getAttribute('data-photos') || '[]');
        // Move newSrc to front of array
        var rest = photos.filter(function (p) { return p !== newSrc; });
        var reordered = [newSrc].concat(rest);
        slide.setAttribute('data-photos', JSON.stringify(reordered));
      } catch (err) {}
    }

    // filter size options; auto-pick the first available size for the new color so the
    // customer isn't dead-ended on "Select" when their previous size isn't offered here
    applyColorFilterToSelect(slide, true);
    var cta = slide.querySelector('[data-inayah-drawer-add]');
    if (cta) {
      cta.removeAttribute('data-variant-id');
      cta.classList.remove('is-added');
    }
    // Re-sync CTA in case there's still a valid pre-selected (or auto-selected) size
    syncCtaFromSelect(slide);
  }, true);

  /* ----------------------------------------------------------------
   * Size dropdown change: enable Add to Bag
   * -------------------------------------------------------------- */
  document.addEventListener('change', function (e) {
    var sel = closest(e.target, '[data-inayah-sizeselect]');
    if (!sel) return;
    var slide = getSlide(sel);
    if (!slide) return;
    var cta = slide.querySelector('[data-inayah-drawer-add]');
    if (!cta) return;
    var opt = sel.options[sel.selectedIndex];
    if (!opt || opt.hasAttribute('data-placeholder') || !opt.value) {
      cta.setAttribute('data-needs-size', '');
      cta.classList.remove('is-ready');
      cta.removeAttribute('data-variant-id');
      cta.textContent = 'Select Size';
      return;
    }
    cta.removeAttribute('data-needs-size');
    cta.classList.add('is-ready');
    cta.setAttribute('data-variant-id', opt.value);
    cta.textContent = 'Add to Bag';
    var fmt = opt.getAttribute('data-price-formatted');
    var priceEl = slide.querySelector('[data-price]');
    if (priceEl && fmt) priceEl.textContent = fmt;
  }, true);

  /* ----------------------------------------------------------------
   * Add to Bag click: POST to /cart/add.js + Minimog refresh
   * -------------------------------------------------------------- */
  var busy = false;
  document.addEventListener('click', function (e) {
    var cta = closest(e.target, '[data-inayah-drawer-add]');
    if (!cta) return;
    if (!getWrap(cta)) return;
    e.preventDefault(); e.stopPropagation();
    if (cta.hasAttribute('data-needs-size')) {
      // No size picked — open size dropdown for them
      var slideForSize = getSlide(cta);
      var selSize = slideForSize && slideForSize.querySelector('[data-inayah-sizeselect]');
      if (selSize) { try { selSize.focus(); selSize.click(); } catch (err) {} }
      busy = false;
      return;
    }
    if (cta.hasAttribute('disabled')) return;
    if (busy) return;
    busy = true;
    var variantId = cta.getAttribute('data-variant-id');
    if (!variantId) { busy = false; return; }
    var original = cta.textContent;
    cta.setAttribute('disabled', 'disabled');
    cta.textContent = 'Adding…';

    cta.classList.add('is-loading');
    var prevItemCount = 0;
    try { prevItemCount = parseInt((document.querySelector('.sf-cart-count') || {}).textContent || '0', 10) || 0; } catch (err) {}

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function (data) {
      cta.classList.add('is-added');
      cta.textContent = 'Added ✓';

      // Trigger Minimog drawer re-render explicitly
      try {
        if (window.MinimogTheme && window.MinimogTheme.Cart) {
          var C = window.MinimogTheme.Cart;
          if (typeof C.refreshCart === 'function') {
            Promise.resolve(C.refreshCart()).then(function () {
              if (typeof C.renderNewCart === 'function') return Promise.resolve(C.renderNewCart());
            }).then(function () {
              if (typeof C.openCartDrawer === 'function') C.openCartDrawer();
            }).catch(function () {});
          }
        }
        if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
          window.Shopify.onItemAdded(data, true);
        }
      } catch (err) {}

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('product:added-to-cart'));
      refreshCartCountBadge();

      // On /cart page: soft reload to update line items
      if (window.location.pathname.indexOf('/cart') === 0) {
        setTimeout(function () { window.location.href = '/cart'; }, 600);
        return;
      }

      // Fallback: if after 1.2s the cart count badge hasn't gone up, force drawer rebuild
      setTimeout(function () {
        var newCount = 0;
        try { newCount = parseInt((document.querySelector('.sf-cart-count') || {}).textContent || '0', 10) || 0; } catch (err) {}
        if (newCount <= prevItemCount && window.MinimogTheme && window.MinimogTheme.Cart) {
          var C2 = window.MinimogTheme.Cart;
          try {
            if (typeof C2.fetchCartSection === 'function') {
              Promise.resolve(C2.fetchCartSection()).then(function (drawer) {
                var container = document.querySelector('#cart-drawer-container');
                if (container && drawer) {
                  container.innerHTML = '';
                  container.appendChild(drawer);
                  if (typeof C2.init === 'function') C2.init();
                  if (typeof C2.openCartDrawer === 'function') C2.openCartDrawer();
                }
              }).catch(function () {});
            }
          } catch (err) {}
        }
      }, 1200);
    })
    .catch(function () {
      cta.textContent = original;
      cta.removeAttribute('disabled');
    })
    .finally(function () {
      setTimeout(function () { busy = false; }, 400);
    });
  }, true);
})();
